import React, { FC } from 'react';
import cn from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { TSlideProp, ICarouselProps } from '../SwiperCarousel';
import 'swiper/css';
require("./SwiperCarouselContainer.css");
var styles = {
  "Root": "SwiperCarouselContainer-module-Root_2S5",
  "Slide": "SwiperCarouselContainer-module-Slide_VNK"
};
const SwiperCarouselContainer = ({
  slides,
  slidesPerView,
  slidesPerGroup,
  arrows,
  autoplay,
  autoplayDelay,
  autoplayDisableOnInteraction,
  autoplayPauseOnMouseEnter,
  spaceBetween,
  loop,
  breakpoints,
  containerClassName,
  slideClassName,
  onInit,
  onRealIndexChange,
  onActiveIndexChange,
  onAfterInit,
  onBeforeDestroy,
  onBeforeInit,
  onDestroy,
  onResize,
  onSlidesLengthChange,
  onSlidesUpdated,
  onUpdate,
  style = {}
}) => {
  return /*#__PURE__*/React.createElement(Swiper, {
    modules: [Navigation, Autoplay],
    className: cn(styles.Root, containerClassName),
    slidesPerView: slidesPerView,
    slidesPerGroup: slidesPerGroup,
    navigation: arrows,
    spaceBetween: spaceBetween,
    autoplay: {
      enabled: autoplay,
      delay: autoplayDelay,
      disableOnInteraction: autoplayDisableOnInteraction,
      pauseOnMouseEnter: autoplayPauseOnMouseEnter
    },
    loop: loop,
    breakpoints: breakpoints,
    watchSlidesProgress: true,
    style: style,
    onSwiper: swiper => onInit && onInit(swiper),
    onRealIndexChange: swiper => onRealIndexChange && onRealIndexChange(swiper),
    onActiveIndexChange: swiper => onActiveIndexChange && onActiveIndexChange(swiper),
    onAfterInit: swiper => onAfterInit && onAfterInit(swiper),
    onBeforeDestroy: swiper => onBeforeDestroy && onBeforeDestroy(swiper),
    onBeforeInit: swiper => onBeforeInit && onBeforeInit(swiper),
    onDestroy: swiper => onDestroy && onDestroy(swiper),
    onResize: swiper => onResize && onResize(swiper),
    onSlidesLengthChange: swiper => onSlidesLengthChange && onSlidesLengthChange(swiper),
    onSlidesUpdated: swiper => onSlidesUpdated && onSlidesUpdated(swiper),
    onUpdate: swiper => onUpdate && onUpdate(swiper)
  }, slides.map((slide, index) => /*#__PURE__*/React.createElement(SwiperSlide, {
    key: `carousel-slide-${index}`,
    className: cn(styles.Slide, slideClassName)
  }, slide)));
};
export default SwiperCarouselContainer;